var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSlider
    ? _c(
        "v-navigation-drawer",
        {
          staticClass: "contest-report-slider-menu",
          attrs: { fixed: "", temporary: "", right: "" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("div", { staticClass: "contest-report-slider-menu--border" }),
          _vm._v(" "),
          _c("div", { staticClass: "contest-report-slider-menu--content" }, [
            _c("div", { staticClass: "contest-report-slider-menu--title" }, [
              _c("span", { staticClass: "slider-menu-title--title" }, [
                _vm._v(_vm._s(_vm.$t("Contests.Slider.Menu.Title")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "slider-menu-title--sportname" }, [
                _vm._v(_vm._s(_vm.contestName))
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "slider-menu-title--round",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("Contests.Slider.Menu.Round", {
                      contestCurrentRound: _vm.contestCurrentRound
                    })
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contest-report-slider-menu--balance" }, [
              _c("span", {
                staticClass: "slider-menu-balance--points",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("Contests.Slider.Menu.Balance.Points")
                  )
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "slider-menu-balance--pointsvalue" }, [
                _vm._v(_vm._s(_vm.pointBalance))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "slider-menu-balance--bottomborder" })
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "contest-report-slider-menu--menu" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: _vm.homePath } }, [
                    _vm._v(_vm._s(_vm.$t("Contests.Slider.Menu.Home")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: _vm.reportsPath + "/leaderboard-position" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Contests.Slider.Menu.Leaderboard.Position", {
                            boardPosition: _vm.boardPosition
                          })
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: _vm.reportsPath + "/view-all-picks-for-round"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Contests.Slider.Menu.View.All.Picks"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.reportsPath + "/my-pick-history" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Contests.Slider.Menu.My.Pick.History"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.reportsPath + "/round-picks-summary" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Contests.Slider.Menu.Round.Picks.Summary")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "contest-report-slider-menu--contests-text" },
            [_vm._v(_vm._s(_vm.$t("Contests.Slider.Menu.Contests.Text")))]
          )
        ]
      )
    : _c("div", { staticClass: "contest-report-slider-menu--desktop" }, [
        _c("div", { staticClass: "contest-report-slider-menu--content" }, [
          _c("ul", { staticClass: "contest-report-slider-menu--menu" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: _vm.homePath } }, [
                  _vm._v(_vm._s(_vm.$t("Contests.Slider.Menu.Home")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: _vm.reportsPath + "/leaderboard-position" } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Contests.Slider.Menu.Leaderboard.Position", {
                          boardPosition: _vm.boardPosition
                        })
                      )
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: { to: _vm.reportsPath + "/view-all-picks-for-round" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Contests.Slider.Menu.View.All.Picks"))
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: _vm.reportsPath + "/my-pick-history" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Contests.Slider.Menu.My.Pick.History"))
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: _vm.reportsPath + "/round-picks-summary" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Contests.Slider.Menu.Round.Picks.Summary"))
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95c29f3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95c29f3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestsReportSliderMenu.vue
// module id = null
// module chunks = 